import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { SIZE_ENUM } from '@/components/@base/@types';
import localization from '@/constant/localization';
import FontIcon from '@/components/@base/font-icon';
import Button from '@/components/@base/button';

const WrongPgc = () => {
  return (
    <Container
      center
      className='h-[100vh] w-full flex-col gap-3 bg-grayLight-0 dark:bg-grayDark-950 px-6 i5:px-8 '
    >
      <FontIcon icon="icon-question" className='text-[40px] text-red bg-red-50 rounded-full h-[56px] w-[56px] flex items-center justify-center'/>
      <Text size={SIZE_ENUM.LG} className='mt-6 text-black dark:text-white leading-7' semiBold>{localization.wrongPgc}</Text>
      <Text size={SIZE_ENUM.MD} className='text-grayLight-850 dark:text-grayDark-75 text-center'>{localization.sorryWrongPgc}</Text>
      <Button
        className='mt-6 text-[18px] rounded-full px-6'
        style={{height: '52px'}}
        size={SIZE_ENUM.XL}
        onClick={() => history.back()}
      >
        <span className="pl-2">{localization.returnToMerchant}</span>
        <FontIcon icon="icon-arrow-top-right" className="text-xl"/>
      </Button>
    </Container>
  );
}
export default WrongPgc;